module.exports = __webpack_public_path__ + "img/btn_yicanyu@2x.68e6154b.png";